import { Carousel } from '@fiverr-private/orca';
import images from './assets';

export const DEFAULT_SLIDES_TO_SHOW = 4;

export const CAROUSEL_BREAKPOINTS = {
    [Carousel.BREAKPOINTS.BP_750]: 1,
    [Carousel.BREAKPOINTS.BP_1000]: 2,
    [Carousel.BREAKPOINTS.BP_1160]: 3,
    [Carousel.BREAKPOINTS.BP_1300]: 4,
};

export const CAROUSEL_INDUSTRIES_SLUGS = [
    {
        slug: 'real_estate',
        image: images.real_estate,
    },
    {
        slug: 'food_and_beverage',
        image: images.food_and_beverage,
    },
    {
        slug: 'beauty_and_cosmetics',
        image: images.beauty_and_cosmetics,
    },
    {
        slug: 'fashion_and_apparel',
        image: images.fashion_and_apparel,
    },
    {
        slug: 'medical_or_pharmaceutical',
        image: images.medical_or_pharmaceutical,
    },
    {
        slug: 'construction',
        image: images.construction,
    },
    {
        slug: 'gaming',
        image: images.gaming,
    },
    {
        slug: 'sports_and_fitness',
        image: images.sports_and_fitness,
    },
];
